/* eslint-disable import/no-cycle,consistent-return,default-case */
import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import cuid from 'cuid';
import Collapse from '../FooterCollapse';
import Wrapper from './Wrapper';
import { accordionTheme } from './theme';
import { FooterBlockContent } from '..';
var FooterAccordion = function (_a) {
    var _b;
    var contentData = _a.contentData, styleType = _a.styleType, _c = _a.componentKey, componentKey = _c === void 0 ? cuid() : _c;
    var elements = [];
    (_b = contentData === null || contentData === void 0 ? void 0 : contentData.filter(function (item) { return item.parent_field_name === 'field_footer'; })) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
        var itemId = item.id, headline = item.field_headline, _a = item.field_is_open, isOpen = _a === void 0 ? false : _a;
        var content = (React.createElement(FooterBlockContent, { key: "footer-block-content-" + componentKey, uuid: componentKey, innerParagraph: item }));
        elements.push(content && (React.createElement(Collapse, { key: "footer-collapse-" + itemId, headline: headline, id: itemId, isOpen: isOpen }, content)));
    });
    return (React.createElement(ThemeProvider, { theme: accordionTheme },
        React.createElement(Wrapper, { className: "footer-accordion-wrapper", styleType: styleType, key: "footer-accordion-wrapper-" + componentKey },
            React.createElement("div", { className: "footer-accordion-row", key: "footer-accordion-row-" + componentKey },
                React.createElement("div", { className: "footer-accordion-col", key: "footer-accordion-col-" + componentKey },
                    React.createElement("div", { className: "footer-accordion-tabs", key: "footer-accordion-tabs-" + componentKey }, elements))))));
};
export default withTheme(FooterAccordion);
//# sourceMappingURL=index.js.map